import { render, staticRenderFns } from "./Pane.vue?vue&type=template&id=0f542cc3&"
import script from "./Pane.vue?vue&type=script&lang=ts&"
export * from "./Pane.vue?vue&type=script&lang=ts&"
import style0 from "./Pane.vue?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

component.options.__file = "Pane.vue"
export default component.exports